import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store(
	{
		state: 
		{
			currentFrame: 35,
		},
		getters: 
		{
			frame(state)
			{
				return state.currentFrame;
			}
		},
		mutations: 
		{
			setFrame(state, value)
			{
				state.currentFrame = Math.max(0, value);
				state.currentFrame = Math.min(state.currentFrame, 70);
			}
		},
		actions: 
		{

		}
	})
